import { Link } from "react-router-dom";
import { PHONE_SHORT, PHONE_TEL } from "../../data/site";
import { Reveal } from "./Reveal";

export const CtaBand = () => (
    <section
        data-testid="cta-band"
        className="grain relative border-t border-white/[0.07] px-5 py-24 text-center md:py-32"
    >
        <Reveal>
            <p className="font-display text-3xl font-light leading-tight tracking-tight text-bone md:text-5xl">
                Vaš automobil zaslužuje više
                <br />
                od <span className="italic text-bronze">običnog pranja.</span>
            </p>
        </Reveal>
        <Reveal delay={0.15}>
            <div className="mt-10 flex flex-wrap items-center justify-center gap-x-10 gap-y-5">
                <Link
                    to="/termin"
                    data-testid="cta-band-book"
                    className="bg-bone px-10 py-4 text-[11px] font-semibold tracking-[0.26em] text-[#0a0a0b] transition-colors duration-300 hover:bg-bronze"
                >
                    ZAKAŽI TERMIN
                </Link>
                <a
                    href={PHONE_TEL}
                    data-testid="cta-band-phone"
                    className="border-b border-bone/30 pb-1 text-sm tracking-[0.22em] text-bone/85 transition-colors duration-300 hover:border-bronze hover:text-bronze"
                >
                    {PHONE_SHORT}
                </a>
            </div>
        </Reveal>
    </section>
);
